import { Component, Input } from '@angular/core';

import { ModalService } from '../../../services';

@Component({
  selector: 'app-ok-cancel-modal',
  templateUrl: './ok-cancel-modal.component.html',
  styleUrl: './ok-cancel-modal.component.scss',
})
export class OkCancelModalComponent {
  @Input() header: string;
  @Input() message: string;
  @Input() okLabel = $localize`Ok`;

  constructor(private modalService: ModalService) {}

  onOk() {
    this.modalService.close();
  }

  onCancel() {
    this.modalService.dismiss();
  }
}
